exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supportItemWrapper .supportItem[data-v-5618e268]{display:block;margin:15px 0;padding:18px 15px;color:#2a2e31;font-weight:700;background:#f8f8f8;box-shadow:3px 3px 0 #dadada;border:1px solid #ececec;border-radius:8px;cursor:pointer;transition:all .2s ease-in-out;text-decoration:none}.supportItemWrapper .supportItem[data-v-5618e268]:hover{color:#fff;background:#f77696;box-shadow:3px 3px 0 #d5637f;border:1px solid #f77696}.supportItemWrapper .supportItem ul[data-v-5618e268]{margin-bottom:0;padding-left:24px}", ""]);

// exports
